import React from "react";
import { useNavigate } from "react-router-dom";
import { Home, QrCode, AlertTriangle, MapPin, User } from "lucide-react";
import { cn } from "../../lib/utils";
import { SKIP_SCAN_ALERT_STATE } from "../../utils/scanAlertNav";

const TAB_CONFIG = {
  home: { id: "home", icon: Home, label: "Home", to: (qrId) => `/${qrId}` },
  myqr: { id: "myqr", icon: QrCode, label: "My QR", to: (qrId) => `/${qrId}/public` },
  emergency: { id: "emergency", icon: AlertTriangle, label: "Emergency", danger: true },
  nearby: { id: "nearby", icon: MapPin, label: "Nearby", to: (qrId) => `/${qrId}/nearby` },
  profile: {
    id: "profile",
    icon: User,
    label: "Profile",
    to: (qrId, isOwner, isAuthenticated) =>
      isOwner || isAuthenticated ? "/profile" : `/${qrId}/edit`,
  },
};

const VARIANT_TABS = {
  default: ["home", "myqr", "emergency", "profile"],
  nearby: ["home", "myqr", "nearby", "profile"],
};

const QrBottomNav = ({
  qrId,
  activeTab,
  isOwner = false,
  isAuthenticated = false,
  variant = "default",
  onEmergency,
  onMyQr,
  className,
}) => {
  const navigate = useNavigate();
  if (!qrId) return null;

  const tabs = VARIANT_TABS[variant] || VARIANT_TABS.default;

  return (
    <nav className={cn("qr-bottom-nav lg:hidden", className)} aria-label="Primary">
      {tabs.map((tabId) => {
        const tab = TAB_CONFIG[tabId];
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;

        const handleClick = () => {
          if (tab.id === "emergency") {
            if (onEmergency) onEmergency();
            else navigate(`/${qrId}/report`);
            return;
          }
          if (tab.id === "myqr" && onMyQr) {
            onMyQr();
            return;
          }
          const path = tab.to(qrId, isOwner, isAuthenticated);
          if (tab.id === "myqr") {
            navigate(path, { state: SKIP_SCAN_ALERT_STATE });
          } else {
            navigate(path);
          }
        };

        return (
          <button
            key={tab.id}
            type="button"
            className={cn(
              "qr-bottom-nav__item",
              tab.danger && "qr-bottom-nav__item--danger",
              isActive && "qr-bottom-nav__item--active",
            )}
            onClick={handleClick}
            aria-current={isActive ? "page" : undefined}
          >
            <span className="qr-bottom-nav__icon">
              <Icon size={20} />
            </span>
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
};

export default QrBottomNav;
